import Grid from '@components/core/layout/Grid';
import { Image } from '@core/Image';
import Button from '@components/core/Button';
import RichText from '@components/core/RichText';
import useMediaQuery from '@helpers/hooks/useMediaQuery';
import { getInternalPath } from '@helpers/internalLink';

export default function ImageTextSection(props) {
  const isMobile = useMediaQuery(640);
  let ctaSolidLink = undefined;
  let ctaGhostLink = undefined;

  if (props.ctaSolid && props.ctaSolid.link) {
    ctaSolidLink = props.ctaSolid.link.internalLink ? getInternalPath(props.ctaSolid.link.internalLink) : props.ctaSolid.link.externalUrl;
  }

  if (props.ctaGhost && props.ctaGhost.link) {
    ctaGhostLink = props.ctaGhost.link.internalLink ? getInternalPath(props.ctaGhost.link.internalLink) : props.ctaGhost.link.externalUrl;
  }

  return (
    <Grid>
      <div className={ `col-span-12 xl:col-span-6 mb-8 md:mb-12 xl:mb-0 relative w-[343px] h-[322px] md:w-full md:h-full order-1 ${ props.imageAlignLeft ? 'md:col-start-1' : 'md:!col-end-13 md:order-2' }` }>
        <Image
          sanityImage={ props.headerImage.image }
          className='rounded-[128px] md:rounded-[180px]'
          layout={ isMobile ? 'fill' : 'responsive' }
          objectFit='cover'
          sizes='(min-width: 1280px) 650px, (min-width: 768px) 850px, 400px'
        />
      </div>
      <div className={ `col-span-12 xl:col-span-4 order-2 ${ props.imageAlignLeft ? ' xl:col-start-8' : ' xl:col-start-1 xl:order-1' }` }>
        <div className='text-heading-md text-heading-md--semibold mb-4'>{ props.heading }</div>
        <RichText text={ props.intro?.text } />
        {
          ctaSolidLink &&
          <Button type='solid' href={ ctaSolidLink } externalUrl={ props.ctaSolid.link.externalUrl ? true : false } className='mr-3 mb-3'>
            <span className='mr-3'>{ props.ctaSolid.label}</span>
          </Button>
        }
        {
          ctaGhostLink &&
          <Button type='ghost' href={ ctaGhostLink } externalUrl={ props.ctaGhost.link.externalUrl ? true : false }>
            <span className='mr-3'>{ props.ctaGhost.label}</span>
          </Button>
        }
      </div>
    </Grid>
  );
}
